module.exports = __webpack_public_path__ + "img/god-ape-quest-map-zoom.502872e5.png";